import React, { useEffect } from "react";
import {
  Modal,
  Box,
  Typography,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  DialogActions,
  Button
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import axios from "axios"; 

interface VideoItem {
  url: string;
  title: string;
  thumbnail: string;
  description?: string;
  duration?: string;
}

interface Props {
  open: boolean;
  onClose: () => void;
  s3Videos: VideoItem[];
  selectedVideos: string[];
  setSelectedVideos: (urls: string[]) => void;
  hoveredVideo: string | null;
  setHoveredVideo: (url: string | null) => void;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
  onSuccess: (video: any) => void;
  consentBundleId: string | number;
}

const SelectFromStockVideoModal: React.FC<Props> = ({
  open,
  onClose,
  s3Videos,
  selectedVideos,
  setSelectedVideos,
  hoveredVideo,
  setHoveredVideo,
  anchorEl,
  setAnchorEl,
  onSuccess,           
  consentBundleId
}) => {
  const toggleSelection = (url: string) => {
    if (selectedVideos.includes(url)) {
      setSelectedVideos(selectedVideos.filter((v) => v !== url));
    } else {
      setSelectedVideos([...selectedVideos, url]);
    }
  };

  const handleMouseEnter = (video: VideoItem, event: React.MouseEvent<HTMLElement>) => {
    setHoveredVideo(video.url);
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setHoveredVideo(null);
    setAnchorEl(null);
  };


const submitDataSt = async (video: VideoItem) => {
 
  const payload = {
    title: video.title,
    description: video.description || "",
    url: video.url,
    duration: video.duration || "",     
    thumbnail: video.thumbnail,
    platform: "s3",
  };
 console.log("Submitting video data:", video);
 console.log("Payload:", payload);
 console.log("Consent Bundle ID:", consentBundleId);
  try {
    const response = await axios.put(`consent_bundle/${consentBundleId}/add_video`, payload);
    if (response.status === 200) {
      console.log("Video added successfully:", response.data);
      onSuccess(response.data);
    } else {
      console.error("Failed to add video:", response.data);
    }
  } catch (error) {
    console.error("Error submitting data:", error);
  }
};


  return (
    <Modal open={open} onClose={onClose}>
  <Box
    sx={{
      backgroundColor: "#fff",
      maxWidth: 900,
      maxHeight: "90vh",
      overflowY: "auto",
      margin: "50px auto",
      p: 4,
      borderRadius: 2,
      boxShadow: 24,
      display: "flex",
      flexDirection: "column",
    }}
  >
    <Typography variant="h6" sx={{ fontWeight: "600", marginBottom: "10px" }}>
      Select videos to add to your playlist
    </Typography>

    {/* Video Grid Section */}
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 2,
        mt: 2,
      }}
    >
      {s3Videos.map((video) => (
        <Card
          key={video.url}
          sx={{
            cursor: "pointer",
            position: "relative",
            borderRadius: "8px",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
            transition: "transform 0.3s ease",
            "&:hover": {
              transform: "scale(1.05)",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
            },
            border: selectedVideos.includes(video.url)
              ? "3px solid #4caf50"
              : "none",
          }}
          onMouseEnter={(e) => handleMouseEnter(video, e)}
          onMouseLeave={handleMouseLeave}
          onClick={() => toggleSelection(video.url)}
        >
          {hoveredVideo === video.url ? (
            <video
              src={video.url}
              width="100%"
              height="120"
              autoPlay
              muted
              loop
              style={{ borderRadius: "8px", objectFit: "cover" }}
            />
          ) : (
            <CardMedia
              component="img"
              height="120"
              image={video.thumbnail}
              alt={video.title}
            />
          )}

          <CardContent>
            <Typography variant="body2" noWrap>
              {video.title}
            </Typography>
          </CardContent>

          {selectedVideos.includes(video.url) && (
            <Box
              sx={{
                position: "absolute",
                top: "5px",
                right: "5px",
                backgroundColor: "rgba(0, 0, 0, 0.6)",
                borderRadius: "50%",
                padding: "5px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CheckCircleIcon sx={{ color: "white" }} />
            </Box>
          )}
        </Card>
      ))}
    </Box>

    
    <Box sx={{ mt: 4 }}>
      <DialogActions sx={{ p: 0, display: "flex", justifyContent: "flex-end" }}>
        <Button
          onClick={() => {
            form.reset();
            setUrl("");
            form.change("url", "");
            form.change("title", "");
            form.change("description", "");
            onClose();
          }}
          color="primary"
        >
          Cancel
        </Button>
       <Button
      onClick={async () => {
        for (const url of selectedVideos) {
          const video = s3Videos.find((v) => v.url === url);
          if (video) {
            await submitDataSt(video); 
          }
        }
        onClose(); 
      }}
      color="primary"
      variant="contained"
      disabled={selectedVideos.length === 0}
    >
      Add
    </Button>
      </DialogActions>
    </Box>
  </Box>
</Modal>

  );
};

export default SelectFromStockVideoModal;
